import { BreakEvenAmountsModel } from "./data/dataStore";
import { spreadsheetGenreMixesLookup } from "./data/spreadsheetData";

const giveCommas = (s: string) => s.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const numberWithCommas = (value: number, decimals: number = 2) => giveCommas(value.toFixed(decimals));
export const rawMoneyFormat = (value: number) => giveCommas(value.toFixed(2));
export const currencyFormat = (value: number, useNegativeSign: boolean = false) => {
    const symbol = "$"; // for now since we will only have $$ for a while
    if (value == undefined) return "-";
    const isNegative = value < 0;
    const useBrackets = !useNegativeSign && isNegative;
    const v = symbol + rawMoneyFormat(useBrackets ? Math.abs(value) : value);
    // surround negative numbers in brackets unless specified otherwise
    return useBrackets ? `(${v})` : v;
}



export const percentDisplay = (ratio: number, decimals: number) => giveCommas((ratio * 100).toFixed(decimals)) + "%";
export const formatPercent = (ratio: number, decimals: number) => {
    return !!ratio
        ? percentDisplay(ratio, decimals)
        : "-"
}

export const makeLookup2 = <TInput, TValue>(list: TInput[], idFun: (o: TInput) => string, valueFun: (o: TInput) => TValue) => {
    const lookup = new Map<string, TValue>();
    list.forEach(c => lookup.set(idFun(c), valueFun(c)));
    return lookup;
}



export const getGenreBasedMixes = (genre: string): BreakEvenAmountsModel => {
    const newMixes = spreadsheetGenreMixesLookup.get(genre);

    return (!!newMixes)
        ? {
            streamingRatio: newMixes.streaming / 100,
            trackVsAlbumsRatio: newMixes.trackVsAlbum / 100,
            digitalVsPhysicalRatio: newMixes.digitalVsPhysical / 100,
        }
        : {
            streamingRatio: 0,
            trackVsAlbumsRatio: 0,
            digitalVsPhysicalRatio: 0,
        }


}